import { Box, Grid } from '@mui/material';
import { InputText } from '@/components/shared/InputText';
import { PrimaryButtonStyle, SecondaryButtonStyle } from './IntegrationDialog';

export interface TwoInputConnectionProps {
    onClose?: () => void;
    input1Value?: string | null;
    input2Value?: string | null;
    input1Label: string;
    input2Label: string;
    input1Placeholder: string;
    input2Placeholder: string;
    input1OnChange: (val: any) => void;
    input2OnChange: (val: any) => void;
    primaryButtonTitle: string;
    secondaryButtonTitle: string;
    onClickPrimary: () => void;
    onClickSecondary: () => void;
    primaryDisabled?: boolean;
    primaryLoading?: boolean;
}

export const TwoInputConnection = (props: TwoInputConnectionProps) => {
    return (
        <>
            <Box width={'100%'} margin={'20px 0 10px'}>
                <InputText
                    value={props?.input1Value}
                    label={props?.input1Label}
                    placeholder={props?.input1Placeholder}
                    onChange={props?.input1OnChange}
                    spacing="10px 0"
                />

                <InputText
                    value={props?.input2Value}
                    label={props?.input2Label}
                    placeholder={props?.input2Placeholder}
                    onChange={props?.input2OnChange}
                    spacing="10px 0"
                />
            </Box>

            <Grid m={'20px 0'} container justifyContent={'space-around'}>
                <SecondaryButtonStyle
                    onClick={props?.onClickSecondary}
                    sx={{ width: '170px' }}
                >
                    {props?.secondaryButtonTitle}
                </SecondaryButtonStyle>

                <PrimaryButtonStyle
                    onClick={props?.onClickPrimary}
                    sx={{ width: '170px' }}
                    loading={props?.primaryLoading}
                    disabled={
                        props?.primaryDisabled ||
                        !props?.input1Value ||
                        !props?.input2Value
                    }
                >
                    {props?.primaryButtonTitle}
                </PrimaryButtonStyle>
            </Grid>
        </>
    );
};
